import { EventDefinitions, type EventPayloads } from "./types";

function validatePayload<T extends keyof EventPayloads>(
  eventName: T,
  payload: EventPayloads[T],
): boolean {
  if (!(eventName in EventDefinitions)) {
    console.groupCollapsed(
      `%cTagular: ERROR | Invalid event name "${eventName}"`,
      "background: #BA5632; color: #fff; padding: 3px 6px;",
    );
    console.log(`%c${eventName} is not a valid event name.`, "color: #BA5632");
    console.groupEnd();
    return false;
  }

  const schema = EventDefinitions[eventName].payload;
  const result = schema.safeParse(payload);

  if (!result.success) {
    console.groupCollapsed(
      `%cTagular: ERROR | Invalid payload for event "${eventName}"`,
      "background: #BA5632; color: #fff; padding: 3px 6px;",
    );
    result.error.errors.forEach((error) => {
      console.log(
        `%c${error.path.join(".")}:`,
        "color: #BA5632",
        error.message,
      );
    });
    console.groupEnd();
    return false;
  }

  return true;
}

export { validatePayload };
